var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.deviceConfigurationList),function(param){return _c('div',{key:param.id},[_c('span',[_vm._v(_vm._s(param.label))]),_c('span',[_vm._v(" = "+_vm._s(param.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }